module.exports = __webpack_public_path__ + "static/img/img-rate-35@3x.9442ccc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotion/img-rate-35@3x.png
// module id = Igzk
// module chunks = 18